export const vocabularies = {
  ja: {
    'User does not exist.': '入力されたメールアドレスは登録されていません',
    'Incorrect username or password.': 'メールアドレスまたはパスワードが違います',
    'Invalid verification code provided, please try again.': '指定された確認コードが無効です。もう一度お試しください',
    'Username cannot be empty': 'メールアドレスは必須です',
    'Enter your email': 'Eメールアドレスを入力',
    'Your passwords must match': 'パスワードを一致させてください',
    'Password attempts exceeded': 'パスワード試行回数が超過しました',
    'Attempt limit exceeded, please try after some time.':
      '試行制限を超過しました。しばらくしてからもう一度お試しください',
    'Password does not conform to policy: Password not long enough':
      'パスワードは8文字以上を入力してください (8文字以上の大文字小文字を含む英数字特殊文字)',
    'Password does not conform to policy: Password must have uppercase characters':
      'パスワードには大文字を含めてください (8文字以上の大文字小文字を含む英数字特殊文字)',
    'Password does not conform to policy: Password must have lowercase characters':
      'パスワードには小文字を含めてください (8文字以上の大文字小文字を含む英数字特殊文字)',
    'Password does not conform to policy: Password must have numeric characters':
      'パスワードには数字を含めてください (8文字以上の大文字小文字を含む英数字特殊文字)',
    'Password does not conform to policy: Password must have symbol characters':
      'パスワードには特殊文字を含めてください (8文字以上の大文字小文字を含む英数字特殊文字)',
    "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128":
      'メールアドレスは128文字以下で指定してください',
    "1 validation error detected: Value at 'userName' failed to satisfy constraint: Member must have length less than or equal to 128":
      'メールアドレスは128文字以下で指定してください',
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
      'パスワードは8文字以上256文字以下、大文字小文字を含む英数字を指定してください',
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256; Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128":
      'メールアドレスは128文字以下で指定してください。パスワードは8文字以上256文字以下、大文字小文字を含む英数字を指定してください',
    'Password must have at least 8 characters':
      'パスワードは8文字以上を入力してください (8文字以上の大文字小文字を含む英数字特殊文字)',
    'Password has previously been used': '同じパスワードを設定することはできません',
    'User password cannot be reset in the current state.': 'パスワードのリセットができない状態です',
    'Invalid session for the user, session is expired.': 'セッションの期限が切れました',
    'Invalid session for the user.': 'セッションの期限が切れました。',
    'Invalid attributes given, new password is too long':
      'パスワードは8文字以上256文字以下、大文字小文字を含む英数字を指定してください',
    'Invalid code provided, please request a code again.':
      'コードの期限が切れています。再度コードをリクエストしてください',
    'Invalid code or auth state for the user.': 'コードの期限が切れています',
    'There is already a signed in user.': '既にログイン済みです。ページをリロードしてください',
  },
  en: {
    'User does not exist.': 'The entered email address is not registered.',
    'Incorrect username or password.': 'Incorrect email address or password.',
    'Username cannot be empty': 'Email address cannot be empty',
    'Password does not conform to policy: Password not long enough':
      'Please enter a password with at least 8 characters (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    'Password does not conform to policy: Password must have uppercase characters':
      'Please include uppercase letters in the password (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    'Password does not conform to policy: Password must have lowercase characters':
      'Please include lowercase letters in the password (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    'Password does not conform to policy: Password must have numeric characters':
      'Please include numbers in the password (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    'Password does not conform to policy: Password must have symbol characters':
      'Please include special characters in the password (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    "1 validation error detected: Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128":
      'Please enter an email address with no more than 128 characters.',
    "1 validation error detected: Value at 'userName' failed to satisfy constraint: Member must have length less than or equal to 128":
      'Please enter an email address with no more than 128 characters.',
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
      'Please enter a password with between 8 and 256 characters, including uppercase and lowercase letters and numbers.',
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256; Value at 'username' failed to satisfy constraint: Member must have length less than or equal to 128":
      'Please enter an email address with no more than 128 characters. Please enter a password with between 8 and 256 characters, including uppercase and lowercase letters and numbers.',
    'Password must have at least 8 characters':
      'Please enter a password with at least 8 characters (at least 8 characters, including uppercase, lowercase letters, numbers, and special characters).',
    'Password has previously been used': 'Setting the same password is not allowed.',
    'Invalid session for the user.': 'The session has expired.',
    'Invalid attributes given, new password is too long':
      'Please enter a password with between 8 and 256 characters, including uppercase and lowercase letters and numbers.',
    'There is already a signed in user.': 'You are already logged in. Please reload the page.',
  },
};
